import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import {
  FormSubmissionPaginatedResponse,
  FormSubmissionDetail,
  FormSubmissionQueryParams,
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private url: string = 'formsubmissions';

  constructor(private apiService: ApiService) {}

  public getFormSubmissions(
    params: FormSubmissionQueryParams = {},
  ): Observable<FormSubmissionPaginatedResponse> {
    const { page = 1, pageSize = 20 } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    }).toString();

    return this.apiService.get<FormSubmissionPaginatedResponse>(
      `${this.url}?${queryParams}`,
    );
  }

  public getFormSubmissionDetail(id: string): Observable<FormSubmissionDetail> {
    return this.apiService.get<FormSubmissionDetail>(`${this.url}/${id}`);
  }

  public markFormSubmissionAsViewed(id: string): Observable<void> {
    return this.apiService.patch<void, object>(`${this.url}/${id}/viewed`, {});
  }
}
